export const fiscal = {
	fiscalData: "Fiscal Data",
	validations: {
		number: "Numbers only",
	},
};
